module.exports = __webpack_public_path__ + "img/logo-red.d089b4ef.svg";